import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import ExpenseImage from "../../assets/img/ExpensesManagement.jpg";
import AnimatedCard from "react-animated-3d-card";
import Tilt from "react-parallax-tilt";

export default function SummaryCard({ totalBalance, currency }) {
  const history = useHistory();
  const [transformStyle, setTransformStyle] = useState({});
  const [isHovered, setIsHovered] = useState(false);

  const [availableBalance, setAvailableBalance] = useState(0);
  const [totalCreatedSum, setTotalCreatedSum] = useState(0);
  const [totalDebitedSum, setTotalDebitedSum] = useState(0);

  useEffect(() => {
    // console.log("Updated totalBalance:", totalBalance);
    // console.log("Currency:", currency);

    setAvailableBalance(totalBalance?.availableBalance);
    setTotalCreatedSum(totalBalance?.totalCreatedSum);
    setTotalDebitedSum(totalBalance?.totalDebitedSum);
  }, [totalBalance, currency]); // Watch both totalBalance and currency

  const OnExpenseClick = () => {
    history.push("/expenses");
  };

  // console.log(totalBalance?.availableBalance, availableBalance);
  return (
    <>
      <div onClick={OnExpenseClick}>
        <Tilt scale={1.1} transitionSpeed={2500}>
          <div className="shadow-lg" style={{ background: "white !important" }}>
            <div className="p-3">
              <div className="text-center">
                <div className="text-center">
                  <span className="text-xl block">Expenses</span>
                  <span className="text-xl block">Management</span>
                </div>
              </div>
              <img
                src={ExpenseImage}
                alt="Quantity Tracking"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="grid grid-cols-3 place-items-center place-content-center ">
              <div
                className="cursor-pointer text-emerald-500 font-semibold border-t border-r border-gray-300 h-full w-full "
                title={`Total Available Balance (${currency}): ${
                  totalBalance?.availableBalance ?? 0
                }`}
              >
                {totalBalance?.availableBalance ?? 0}
              </div>
              <div
                className="cursor-pointer text-orange-500 font-semibold border-t border-gray-300 h-full w-full"
                title={`Total Credited (${currency}): ${
                  totalBalance?.totalCreatedSum ?? 0
                }`}
              >
                {totalBalance?.totalCreatedSum}
              </div>
              <div
                className="cursor-pointer text-red-500 font-semibold border-t border-l border-gray-300 h-full w-full"
                title={`Total Debited (${currency}): ${
                  totalBalance?.totalDebitedSum ?? 0
                }`}
              >
                {totalBalance?.totalDebitedSum}
              </div>
            </div>
          </div>
        </Tilt>
      </div>

      {/* <div className="inline-flex img-balance row">
        <div
          style={{ border: "solid 1px", cursor: "pointer" }}
          className="col-sm-4"
          title={`Total Available Balance (${currency}): ${
            totalBalance?.availableBalance ?? 0
          }`}
        >
          <span className="text-emerald-500 font-semibold">
            {totalBalance?.availableBalance ?? 0}
          </span>
        </div>
        <div
          className="transparent col-sm-4"
          style={{ border: "solid 1px", cursor: "pointer" }}
          title={`Total Credited (${currency}): ${
            totalBalance?.totalCreatedSum ?? 0
          }`}
        >
          <span className="text-orange-500 font-semibold">
            {totalBalance?.totalCreatedSum}
          </span>
        </div>
        <div
          className="transparent col-sm-4"
          style={{ border: "solid 1px", cursor: "pointer" }}
          title={`Total Debited (${currency}): ${
            totalBalance?.totalDebitedSum ?? 0
          }`}
        >
          <span className="text-red-500 font-semibold">
            {totalBalance?.totalDebitedSum}
          </span>
        </div>
      </div> */}
    </>
  );
}

SummaryCard.propTypes = {
  totalBalance: PropTypes.shape({
    availableBalance: PropTypes.number,
    totalCreatedSum: PropTypes.number,
    totalDebitedSum: PropTypes.number,
  }).isRequired,
  currency: PropTypes.string.isRequired,
};
